<script setup lang="ts">
import { clearError } from '#app'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  error: Object
})

const isDev = import.meta.env.MODE !== 'production'

const handleError = () => {
  clearError({ redirect: '/home' })
}
</script>

<template>
  <div class="min-h-screen bg-white flex flex-col items-center justify-center px-4">
    <div class="text-center max-w-4xl w-full">
      <div class="text-9xl font-bold text-gray-900 mb-4">{{ error?.statusCode || 500 }}</div>

      <h1 class="text-2xl font-bold text-gray-800 mb-6">
        {{ error?.statusCode === 404 ? t('exception.page_not_found') : t('exception.server_error') }}
      </h1>

      <div class="text-gray-500 mb-8">
        <p class="text-red-500 font-medium mb-4">{{ isDev ? '测试环境 - ' : '' + error?.message }}</p>
        <pre class="text-left bg-gray-100 p-4 rounded-lg overflow-x-auto text-xs text-gray-700 font-mono">{{
          error?.stack
        }}</pre>
      </div>

      <button
        @click="handleError"
        class="inline-flex items-center justify-center px-8 py-3 text-base font-medium text-white bg-gray-900 rounded-full hover:bg-gray-800 transition-colors duration-200 cursor-pointer">
        {{ t('exception.back_to_home') }}
      </button>
    </div>
  </div>
</template>
